<div id="home-page">
    <div class="cover-photo" style="position: relative; z-index: 3; left: 0; right: 0; height: 200px">
    </div>

    <div class="extra-light-grey-cfa-languedoc-bg" style="position: relative; z-index: 10;">
        <div class="container white-bg" style="position: relative; z-index: 11;">

            <div style="margin-left: -15px; margin-top: -110px !important; position: absolute; z-index: 12;">
                <h1 class="col-12 p-2 bandeau-title white blue-cfa-languedoc-bg font-weight-bold" style="display: table">Offres d'emploi - contrats en alternance</h1>
                <h2 class="col-12 p-2 bandeau-subtitle brown-2-cfa-languedoc-bg font-weight-bold">Contrats disponibles immédiatement</h2>
            </div>    

            <div class="row">

                <div class="col-12 col-lg-9 px-5 mt-4">

                    <div *ngFor="let offre of offresEmploi" class="mb-4 light-grey-2-cfa-languedoc-bg offre">
                        <img [src]="'https://www.apprentissage-montpellier.education/img/offres-emploi/' + offre.illustration" class="offre__img">
                        <div class="offre__info">
                            <span class="offre__info__title font-weight-bold">
                                {{offre.titre_job}} 
                                <ng-container *ngIf="offre.ville"> à {{offre.ville}}</ng-container>
                            </span>
                            <span class="offre__info__item">
                                <span class="offre__info__item__key">
                                    Dans le cadre de la formation :
                                </span>
                                <span class="offre__info__item__value font-weight-bold">
                                    {{offre.formation}}
                                </span>
                            </span>
                            <span class="offre__info__item">
                                <span class="offre__info__item__key">
                                    Secteur d'activité :
                                </span>
                                <span class="offre__info__item__value">
                                    {{offre.secteur_activite}}
                                </span>
                            </span>
                            <span class="offre__info__item">
                                <span class="offre__info__item__key">
                                    Début de la présence en entreprise :
                                </span>
                                <span class="offre__info__item__value">
                                    {{offre.date_debut_mission | date:'longDate':'fr'}}
                                </span>
                            </span>
                            <span class="offre__info__item">
                                <span class="offre__info__item__key">
                                    Durée :
                                </span>
                                <span class="offre__info__item__value">
                                    {{offre.duree_mission}}
                                </span>
                            </span>
                        </div>
                        <div class="offre__button">
                            <button class="orange-cfa-languedoc-bg" [routerLink]="[offre.id_offre_emploi]">VOIR L'OFFRE</button>
                        </div>
                    </div>
                
                </div>

                <div class="hide-on-small-and-medium col-lg-3">

                    <ng-container *ngFor="let pave of paves">
                        <a [href]="pave.url_destination" class="no-underline" [target]="pave.nouvel_onglet === '1' ? '_blank' : '_self'">
                            <div class="mb-4 mt-4 pave ombre-clickable">
                                <div class="pave__haut" [style.backgroundColor]="pave.couleur_fond_haut">
                                    <p class="pave__haut__text" [style.color]="pave.couleur_texte_haut" [innerHTML]="pave.html_div_haut"></p>
                                    <img class="pave__haut__img" [src]="'https://www.apprentissage-montpellier.education/img/paves/' + pave.image_haut_droite">
                                </div>
                                <div class="pave__bas" [style.backgroundColor]="pave.couleur_fond_bas">
                                    <p class="pave__bas__text" [style.color]="pave.couleur_texte_bas" [innerHTML]="pave.html_div_bas"></p>
                                    <img class="pave__bas__img" [src]="'https://www.apprentissage-montpellier.education/img/paves/' + pave.image_bas_droite">
                                </div>
                            </div>
                        </a>
                    </ng-container>

                </div>

            </div>

        </div>
    </div>
</div>